import { PROJECT_VENUS_MODEL, VENUS_NOVA_MODEL } from "./self-hosted-experiment.js";
/** A target may pin operator comparisons to subscription auth without changing user traffic. */
export function evaluationOpenAIEnvironment(modelConfig, env) {
    const executor = modelConfig?.executor;
    if (!executor?.evaluationHarness || executor.provider !== "openai")
        return env;
    const auth = env.MLX_HARNESS_EVALUATION_OPENAI_AUTH_ORDER?.trim();
    if (!auth)
        return env;
    if (env.MLX_HARNESS_EVALUATION_ENABLED !== "true" || auth !== "codex_subscription") {
        throw new Error("harness_evaluation_subscription_auth_invalid");
    }
    return { ...env, MLX_OPENAI_AUTH_ORDER: auth, OPENAI_API_KEY: undefined };
}
/** Scope the existing exact-artifact parent binding to explicitly admitted runs. */
export function evaluationParentEnvironment(modelConfig, env) {
    const executor = modelConfig?.executor;
    if (!executor?.evaluationHarness || executor.provider !== "modal" || executor.model !== PROJECT_VENUS_MODEL)
        return env;
    const path = env.MLX_HARNESS_EVALUATION_PARENT_BINDING_FILE?.trim();
    const apiKey = env.MLX_HARNESS_EVALUATION_PARENT_API_KEY?.trim();
    if (env.MLX_HARNESS_EVALUATION_ENABLED !== "true" || !path?.startsWith("/") || !apiKey) {
        throw new Error("harness_evaluation_parent_binding_unavailable");
    }
    return { ...env, MLX_VENUS_PARENT_BINDING_FILE: path, MLX_VENUS_PARENT_BINDING_API_KEY: apiKey };
}
/** Server-only evaluation routing never mutates the ordinary production route. */
export function evaluationNovaBinding(modelConfig, env) {
    const executor = modelConfig?.executor;
    if (!executor?.evaluationHarness || executor.provider !== "modal" || executor.model !== VENUS_NOVA_MODEL)
        return undefined;
    const raw = env.MLX_HARNESS_EVALUATION_NOVA_BASE_URL?.trim();
    const apiKey = env.MLX_HARNESS_EVALUATION_NOVA_API_KEY?.trim();
    if (env.MLX_HARNESS_EVALUATION_ENABLED !== "true" || !raw || !apiKey) {
        throw new Error("harness_evaluation_nova_binding_unavailable");
    }
    let url;
    try {
        url = new URL(raw);
    }
    catch {
        throw new Error("harness_evaluation_nova_binding_invalid");
    }
    if (url.protocol !== "https:" || !url.hostname.endsWith(".modal.run") ||
        !url.hostname.includes("-venus-nova-maintenance--") ||
        url.username || url.password || url.port || url.search || url.hash ||
        url.pathname.replace(/\/+$/u, "") !== "/v1") {
        throw new Error("harness_evaluation_nova_binding_requires_isolated_maintenance");
    }
    const baseUrl = raw.replace(/\/+$/u, "");
    if (baseUrl === env.MLX_VENUS_NOVA_BASE_URL?.trim().replace(/\/+$/u, "")) {
        throw new Error("harness_evaluation_nova_binding_shares_production");
    }
    return { baseUrl, apiKey };
}
